<template>
  <div
    :class="[
      // Mantener posicionamiento original en desktop (solo visual)
      'flex flex-col right-[13rem] -translate-y-[.5rem] rounded-md py-2 gap-2',
      'static md:absolute w-[90%] md:w-[400px] mx-auto md:mx-0 z-30 md:mt-0',
      // Contenedor mockup (gris + bordes grandes)
      'bg-GRIS_CLARO rounded-[28px] px-6 pt-6 pb-8',
      containerClasses,
    ]"
  >
  
    <!-- STEPPER (mockup) -->
    <div class="flex items-center justify-center gap-3 mb-4">
      <!-- Paso 1: Búsqueda (activo) -->
      <div
        class="w-[75px] h-[64px] rounded-2xl border-2 border-VERDE_TOP_CALIDAD bg-white flex flex-col items-center justify-center"
      >
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="text-[#1C1B1F]"
        >
          <path
            d="M11.25 20C13.6667 20 15.7292 19.151 17.4375 17.4531C19.1458 15.7552 20 13.6875 20 11.25C20 8.83333 19.1458 6.77083 17.4375 5.0625C15.7292 3.35417 13.6667 2.5 11.25 2.5C8.8125 2.5 6.74479 3.35417 5.04688 5.0625C3.34896 6.77083 2.5 8.83333 2.5 11.25C2.5 13.6875 3.34896 15.7552 5.04688 17.4531C6.74479 19.151 8.8125 20 11.25 20ZM11.25 14.375C12.125 14.375 12.8646 14.0781 13.4688 13.4844C14.0729 12.8906 14.375 12.1458 14.375 11.25C14.375 10.375 14.0729 9.63542 13.4688 9.03125C12.8646 8.42708 12.125 8.125 11.25 8.125C10.3542 8.125 9.60938 8.42708 9.01562 9.03125C8.42188 9.63542 8.125 10.375 8.125 11.25C8.125 12.1458 8.42188 12.8906 9.01562 13.4844C9.60938 14.0781 10.3542 14.375 11.25 14.375ZM11.25 16.25C9.52083 16.25 7.98438 15.7865 6.64062 14.8594C5.29688 13.9323 4.33333 12.7292 3.75 11.25C4.33333 9.79167 5.29688 8.59375 6.64062 7.65625C7.98438 6.71875 9.52083 6.25 11.25 6.25C12.9583 6.25 14.4844 6.71875 15.8281 7.65625C17.1719 8.59375 18.1458 9.79167 18.75 11.25C18.1458 12.7292 17.1719 13.9323 15.8281 14.8594C14.4844 15.7865 12.9583 16.25 11.25 16.25ZM23.2188 25L18.25 20.0625C17.2708 20.8333 16.1875 21.4323 15 21.8594C13.8125 22.2865 12.5625 22.5 11.25 22.5C9.6875 22.5 8.22396 22.2031 6.85938 21.6094C5.49479 21.0156 4.30729 20.2135 3.29688 19.2031C2.28646 18.1927 1.48438 17.0052 0.890625 15.6406C0.296875 14.276 0 12.8125 0 11.25C0 9.70833 0.296875 8.25521 0.890625 6.89063C1.48438 5.52604 2.28646 4.33333 3.29688 3.3125C4.30729 2.29167 5.49479 1.48438 6.85938 0.890625C8.22396 0.296875 9.6875 0 11.25 0C12.7917 0 14.2448 0.296875 15.6094 0.890625C16.974 1.48438 18.1667 2.29167 19.1875 3.3125C20.2083 4.33333 21.0156 5.52604 21.6094 6.89063C22.2031 8.25521 22.5 9.70833 22.5 11.25C22.5 12.5833 22.2812 13.8438 21.8438 15.0313C21.4062 16.2188 20.8021 17.3021 20.0312 18.2812L25 23.25L23.2188 25Z"
            fill="currentColor"
          />
        </svg>
        <span class="text-[11px] font-semibold text-[#1C1B1F]">Búsqueda</span>
      </div>

      
      <svg
        class="w-6 h-6 text-[#1C1B1F]"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 6L15 12L9 18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <!-- Paso 2: Local (inactivo) -->
      <div
        class="w-[75px] h-[64px] rounded-2xl border border-gray-200 bg-gray-50 flex flex-col items-center justify-center opacity-60"
      >
        <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.5 0H1.0625C0.474805 0 0 0.474805 0 1.0625V25.5C0 26.0877 0.474805 26.5625 1.0625 26.5625H25.5C26.0877 26.5625 26.5625 26.0877 26.5625 25.5V1.0625C26.5625 0.474805 26.0877 0 25.5 0ZM8.89844 19.3906C8.16465 19.3906 7.57031 18.7963 7.57031 18.0625C7.57031 17.3287 8.16465 16.7344 8.89844 16.7344C9.63223 16.7344 10.2266 17.3287 10.2266 18.0625C10.2266 18.7963 9.63223 19.3906 8.89844 19.3906ZM8.89844 14.6094C8.16465 14.6094 7.57031 14.015 7.57031 13.2812C7.57031 12.5475 8.16465 11.9531 8.89844 11.9531C9.63223 11.9531 10.2266 12.5475 10.2266 13.2812C10.2266 14.015 9.63223 14.6094 8.89844 14.6094ZM8.89844 9.82812C8.16465 9.82812 7.57031 9.23379 7.57031 8.5C7.57031 7.76621 8.16465 7.17188 8.89844 7.17188C9.63223 7.17188 10.2266 7.76621 10.2266 8.5C10.2266 9.23379 9.63223 9.82812 8.89844 9.82812ZM18.9922 18.8594C18.9922 19.0055 18.8727 19.125 18.7266 19.125H12.6172C12.4711 19.125 12.3516 19.0055 12.3516 18.8594V17.2656C12.3516 17.1195 12.4711 17 12.6172 17H18.7266C18.8727 17 18.9922 17.1195 18.9922 17.2656V18.8594ZM18.9922 14.0781C18.9922 14.2242 18.8727 14.3438 18.7266 14.3438H12.6172C12.4711 14.3438 12.3516 14.2242 12.3516 14.0781V12.4844C12.3516 12.3383 12.4711 12.2188 12.6172 12.2188H18.7266C18.8727 12.2188 18.9922 12.3383 18.9922 12.4844V14.0781ZM18.9922 9.29688C18.9922 9.44297 18.8727 9.5625 18.7266 9.5625H12.6172C12.4711 9.5625 12.3516 9.44297 12.3516 9.29688V7.70312C12.3516 7.55703 12.4711 7.4375 12.6172 7.4375H18.7266C18.8727 7.4375 18.9922 7.55703 18.9922 7.70312V9.29688Z" fill="#363636"/>
        </svg>
        <span class="text-[12px] font-semibold">Agenda</span>
      </div>

      
      <svg
        class="w-6 h-6 text-[#1C1B1F]"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 6L15 12L9 18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <!-- Paso 3: Agenda (inactivo) -->
      <div
        class="w-[75px] h-[64px] rounded-2xl border border-gray-200 bg-gray-50 flex flex-col items-center justify-center opacity-60"
      >
        <svg width="20" height="25" viewBox="0 0 20 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 15C10.6875 15 11.276 14.7552 11.7656 14.2656C12.2552 13.776 12.5 13.1875 12.5 12.5C12.5 11.8125 12.2552 11.224 11.7656 10.7344C11.276 10.2448 10.6875 10 10 10C9.3125 10 8.72396 10.2448 8.23438 10.7344C7.74479 11.224 7.5 11.8125 7.5 12.5C7.5 13.1875 7.74479 13.776 8.23438 14.2656C8.72396 14.7552 9.3125 15 10 15ZM5 20H15V19.2812C15 18.7812 14.8646 18.3229 14.5938 17.9062C14.3229 17.4896 13.9479 17.1771 13.4688 16.9688C12.9271 16.7396 12.3698 16.5625 11.7969 16.4375C11.224 16.3125 10.625 16.25 10 16.25C9.375 16.25 8.77604 16.3125 8.20312 16.4375C7.63021 16.5625 7.07292 16.7396 6.53125 16.9688C6.05208 17.1771 5.67708 17.4896 5.40625 17.9062C5.13542 18.3229 5 18.7812 5 19.2812V20ZM17.5 25H2.5C1.8125 25 1.22396 24.7552 0.734375 24.2656C0.244792 23.776 0 23.1875 0 22.5V2.5C0 1.8125 0.244792 1.22396 0.734375 0.734375C1.22396 0.244792 1.8125 0 2.5 0H12.5L20 7.5V22.5C20 23.1875 19.7552 23.776 19.2656 24.2656C18.776 24.7552 18.1875 25 17.5 25Z" fill="#363636"/>
        </svg>
        <span class="text-[12px] font-semibold">Datos</span>
      </div>
    </div>

    <!-- TÍTULO (mockup) -->
    <p class="flex justify-center items-center gap-2 text-ROJO_LEON font-semibold text-base md:text-lg">
      <img class="h-3 translate-y-[1px]" :src="'/img/shared/point-arrow-iconv2.svg'" alt="point-arrow-icon" />
      <span>
        Agenda <span class="font-extrabold">GRATIS</span> tu revisión
      </span>
    </p>

    <!-- Tabs -->
    <OpcionesGenerico
      v-if="mostrar_tabs_busqueda"
      :initialValue="selectedSearchType"
      @selectedOption="selectedOption"
    />

    <!-- FORM -->
    <div class="flex flex-col gap-4">
      <!-- Por AUTO (solo si está habilitado y el modo efectivo es por_auto) -->
      <div v-if="habilita_auto && selectedSearchType === 'por_auto'" class="py-1">
        <AutoSelectorTresCamposGenerico
          :modo_sistema="modo_sistema_efectivo"
          @carSelected="onCarSelected"
        />
      </div>

      <!-- Por PATENTE (solo si está habilitado y el modo efectivo es por_patente) -->
      <div v-if="habilita_patente && selectedSearchType === 'por_patente'" class="">
        <InputCarPlate
          ref="inputCarPlateRef"
          :value="patenteActual"
          @changePlate="changePlate"
          @plateCompleted="onPlateCompleted"
        />
      </div>

      <!-- Ubicación -->
      <div class="flex flex-col items-center">
        <p class="flex justify-center items-center gap-2 text-ROJO_LEON font-bold text-base md:text-lg">
          <img class="h-3 translate-y-[1px]" :src="'/img/shared/point-arrow-iconv2.svg'" alt="point-arrow-icon" />
          ¿Dónde te encuentras?
        </p>


        <SelectCustomV2
          :value="selectedLocal"
          :opciones="locales"
          :disabled="loadingLocales"
          :texto="texto_ubicacion"
          custom-class="leon_select_inner min-h-[38px]"
          imagen_modal="location_on"
          @changeValue="onLocalSelected"
        />

        <!-- Botón -->
        <button
          :disabled="!busqueda_valida || !localSelected"
          @click="handleSearch"
          :class="[
            'mt-5 w-[68%] max-w-[280px] h-[48px] rounded-[12px] flex items-center justify-center gap-2 font-bold text-[15px] transition',
            (!busqueda_valida || !localSelected) ? 'bg-[#E6E6E6] text-black cursor-not-allowed' : 'bg-VERDE_TOP_CALIDAD text-white',
          ]"
        >
          Buscar
          <LoaderSvg v-if="isSearching" fillColor="currentFill" sizeClass="w-4 h-4" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import LoaderSvg from "~/components/Ui/LoaderSvg.vue"
import InputCarPlate from "~/components/Inputs/InputCarPlate.vue"
import OpcionesGenerico from "~/components/Selectores/OpcionesGenerico.vue"
import AutoSelectorTresCamposGenerico from "~/components/Selectores/AutoSelectorTresCamposGenerico.vue"
import SelectCustomV2 from "~/components/Selectores/SelectCustomV2.vue"
import { NEGOCIOS } from "~/constants/negocios"

import { useStore } from "vuex"

const store = useStore()
const modo_sistema_state = useState("modo_sistema")
const router = useRouter()
const route = useRoute()
const TAG = "[FormularioGenerico]"

const props = defineProps({
  modo_sistema: { type: String, required: false, default: "" },
  store_ns: { type: String, required: false, default: "" },
  mostrar_busqueda_auto: { type: Boolean, required: false, default: true },
  mostrar_busqueda_patente: { type: Boolean, required: false, default: true },
  store_map: {
    type: Object,
    required: false,
    default: () => ({
      getters: { searchData: "getSearchData" },
      mutations: {
        setSearchData: "SET_SEARCH_DATA",
        resetSearchData: "RESET_SEARCH_DATA",
        resetDetalle: "RESET_DETALLE_AGENDAMIENTO",
        loadFromStorage: "LOAD_FROM_STORAGE",
        setPatenteSearch: "SET_PATENTE_SEARCH",
        setAutoSearch: "SET_AUTO_SEARCH",
        setDetalleAgendamiento: "SET_DETALLE_AGENDAMIENTO",
      },
    }),
  },
  category: { type: String, required: false, default: "" },
})

// modo_sistema efectivo: prop > state > ruta
const modo_sistema_efectivo = computed(() => {
  const entrada = (props.modo_sistema || "").trim()
  if (entrada) return entrada

  const st = (modo_sistema_state.value || "").trim()
  if (st) return st

  return (route.path.split("/").filter(Boolean)[0] || "").trim()
})

const normalizar_ns = (v) =>
  (v ?? "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[\s\-_]+/g, "")
    .replace(/[^a-z0-9]/g, "")

const STORE_NS_POR_NEGOCIO = {
  [NEGOCIOS.ACEITES]: "aceites",
  [NEGOCIOS.AFINAMIENTO]: "afinamiento",
  [NEGOCIOS.TRENDELANTERO]: "trendelantero",
  [NEGOCIOS.GEOMETRIA]: "geometria",
  [NEGOCIOS.KILOMETRAJE]: "kilometraje",
  [NEGOCIOS.ELECTRICO]: "electrico",
  [NEGOCIOS.REVISIONTECNICA]: "revisiontecnica",
}

const resolver_ns = (candidato) => {
  const raw = (candidato || "").trim()
  const mapped = STORE_NS_POR_NEGOCIO[raw]
  if (mapped && store.hasModule?.(mapped)) return mapped

  if (raw && store.hasModule?.(raw)) return raw

  const norm = normalizar_ns(raw)
  if (norm && store.hasModule?.(norm)) return norm

  return ""
}

// namespace con fallback
const ns = computed(() => {
  const ns_prop = resolver_ns(props.store_ns)
  if (ns_prop) return ns_prop

  const desde_modo = resolver_ns(modo_sistema_efectivo.value)
  if (desde_modo) return desde_modo

  return "frenos"
})

const g = (alias) => `${ns.value}/${props.store_map.getters[alias]}`
const m = (alias) => `${ns.value}/${props.store_map.mutations[alias]}`

// commit seguro
const commit_seguro = (mutation_path, payload = undefined) => {
  const existe = !!store._mutations?.[mutation_path]
  if (!existe) {
    console.error(`${TAG} Mutation no existe:`, mutation_path, { ns: ns.value, payload })
    return false
  }
  store.commit(mutation_path, payload)
  return true
}
const commit_detalle_seguro = (payload) => {
  // 1) Intento por store_map (si existe)
  const by_map = m("setDetalleAgendamiento")
  if (by_map && store._mutations?.[by_map]) {
    store.commit(by_map, payload)
    return true
  }

  // 2) Fallback directo (nombre estándar en tus módulos)
  const fallback = `${ns.value}/SET_DETALLE_AGENDAMIENTO`
  if (store._mutations?.[fallback]) {
    store.commit(fallback, payload)
    return true
  }

  console.error(`${TAG} No existe mutation para detalle_agendamiento`, { ns: ns.value, payload })
  return false
}
const get_search_data_seguro = () => {
  const key = g("searchData")
  const data = store.getters?.[key]
  return (
    data ?? {
      modo_busqueda: "por_auto",
      patente: "",
      local: "",
      marca: "",
      modelo: "",
      ano: "",
    }
  )
}

// VALIDACIÓN (igual)
const limpiar = (v) => (v ?? "").toString().trim()
const es_no_vacio = (v) => limpiar(v) !== ""
const limpiar_campo_tabla = (v) => {
  const s = (v ?? "").toString().trim()
  // en tu CSV hay valores "\0" que significan "vacío"
  if (!s || s === "\\0" || s.toLowerCase() === "null" || s.toLowerCase() === "undefined") return ""
  return s
}
const normalizar_texto = (v) => limpiar_campo_tabla(v)

// OJO: aquí NO hay fallback a opcion_select a propósito
const obtener_direccion = (l) => normalizar_texto(
  l?.direccion ??
  l?.address ??
  l?.direccion_local ??
  l?.local_direccion ??
  l?.direccion_sucursal ??
  l?._raw?.direccion ??
  l?._raw?.address ??
  l?._raw?.direccion_local ??
  l?._raw?.local_direccion ??
  l?._raw?.direccion_sucursal ??
  ""
)

const obtener_comuna = (l) => normalizar_texto(
  l?.comuna ??
  l?.comuna_nombre ??
  l?.comunaName ??
  l?._raw?.comuna ??
  l?._raw?.comuna_nombre ??
  ""
)

const obtener_region = (l) => normalizar_texto(
  l?.region ??
  l?.region_nombre ??
  l?.regionName ??
  l?._raw?.region ??
  l?._raw?.region_nombre ??
  ""
)

const formatear_local_direccion = (l) => {
  const direccion = obtener_direccion(l)
  const comuna    = obtener_comuna(l)
  const region    = obtener_region(l)

  return [direccion, comuna, region].filter(Boolean).join(", ")
}

const validar_datos_vehiculo_generico = ({ marca, ano, modelo, local }) =>
  es_no_vacio(marca) && es_no_vacio(ano) && es_no_vacio(modelo) && es_no_vacio(local)

const validar_datos_patente_generico = ({ patente, local }) =>
  es_no_vacio(patente) && es_no_vacio(local)

const validar_busqueda_generica = (data) => {
  const modo = limpiar(data?.modo_busqueda)
  const local = limpiar(data?.local)
  if (!local) return false
  if (modo === "por_patente") return es_no_vacio(data?.patente)
  return es_no_vacio(data?.marca) && es_no_vacio(data?.ano) && es_no_vacio(data?.modelo)
}

const FACTORY_VALIDADORES_POR_NS = {
  aceites: () => (typeof useAceites === "function" ? useAceites() : null),
  frenos: () => (typeof useFrenos === "function" ? useFrenos() : null),
  afinamiento: () => (typeof useAfinamiento === "function" ? useAfinamiento() : null),
  amortiguadores: () => (typeof useAmortiguadores === "function" ? useAmortiguadores() : null),
  balanceo: () => (typeof useBalanceo === "function" ? useBalanceo() : null),
  geometria: () => (typeof useGeometria === "function" ? useGeometria() : null),
  kilometraje: () => (typeof useKilometraje === "function" ? useKilometraje() : null),
  higienizacion: () => (typeof useHigienizacion === "function" ? useHigienizacion() : null),
  fluidos: () => (typeof useFluidos === "function" ? useFluidos() : null),
  alineacion: () => (typeof useAlineacion === "function" ? useAlineacion() : null),
  electrico: () => (typeof useElectrico === "function" ? useElectrico() : null),
  accesorios: () => (typeof useAccesorios === "function" ? useAccesorios() : null),
  trendelantero: () => (typeof useTrenDelantero === "function" ? useTrenDelantero() : null),
  revisiontecnica: () => (typeof useRevisionTecnica === 'function' ? useRevisionTecnica() : null),
}

const cache_validadores = new Map()

const get_api_validadores = () => {
  const key = (ns.value || "").trim() || "frenos"
  if (cache_validadores.has(key)) return cache_validadores.get(key)

  const factory = FACTORY_VALIDADORES_POR_NS[key] || FACTORY_VALIDADORES_POR_NS.frenos
  const api = factory ? factory() : null
  cache_validadores.set(key, api)
  return api
}

const validarDatosVehiculo = (payload) => {
  const api = get_api_validadores()
  const fn = api?.validarDatosVehiculo
  return typeof fn === "function" ? fn(payload) : validar_datos_vehiculo_generico(payload)
}

const validarDatosPatente = (payload) => {
  const api = get_api_validadores()
  const fn = api?.validarDatosPatente
  return typeof fn === "function" ? fn(payload) : validar_datos_patente_generico(payload)
}

const validarBusqueda = (payload) => {
  const api = get_api_validadores()
  const fn = api?.validarBusqueda
  return typeof fn === "function" ? fn(payload) : validar_busqueda_generica(payload)
}

// COMPUTED
const searchData = computed(() => get_search_data_seguro())
const selectedSearchType = computed(() => modo_busqueda_efectivo.value)
const patenteActual = computed(() => searchData.value.patente ?? "")
const selectedLocal = computed(() => searchData.value.local ?? "")

const busqueda_valida = computed(() => {
  const payload = { ...(searchData.value || {}), modo_busqueda: modo_busqueda_efectivo.value }
  return validarBusqueda(payload)
})

const containerClasses = computed(() => [
  selectedSearchType.value === "por_auto" ? "md:-translate-y-[35rem]" : "md:-translate-y-[35rem]",
])

const localSelected = computed(() => selectedLocal.value !== "")

const texto_ubicacion = computed(() => {
  if (loadingLocales.value) return "Cargando..."
  return (modo_busqueda_efectivo.value === "por_patente") ? "Ingresa tu dirección" : "Ingresa tu ubicación"
})

const habilita_auto = computed(() => props.mostrar_busqueda_auto !== false)
const habilita_patente = computed(() => props.mostrar_busqueda_patente !== false)

// default histórico (tu sistema parte en por_auto si existe)
const modo_default = computed(() => (habilita_auto.value ? "por_auto" : "por_patente"))

const modos_disponibles = computed(() => {
  const modos = []
  if (habilita_auto.value) modos.push("por_auto")
  if (habilita_patente.value) modos.push("por_patente")

  // hardening: si ambos vienen false, evitamos dejar el componente “muerto”
  if (modos.length === 0) {
    console.warn(`${TAG} Ambos modos ocultos. Forzando por_patente como fallback.`)
    modos.push("por_patente")
  }
  return modos
})

const mostrar_tabs_busqueda = computed(() => modos_disponibles.value.length > 1)

// modo efectivo: si solo hay 1 opción, se fuerza; si hay 2, respeta store; si store trae inválido, corrige
const modo_busqueda_efectivo = computed(() => {
  if (modos_disponibles.value.length === 1) return modos_disponibles.value[0]

  const actual = limpiar(searchData.value?.modo_busqueda) || modo_default.value
  return modos_disponibles.value.includes(actual) ? actual : modo_default.value
})

// FUNCIONES
const changePlate = (value) => {
  commit_seguro(m("setSearchData"), { patente: value })
}

// Evita quiebre si plateCompleted existía sin handler (no cambia flujo)
const onPlateCompleted = (value) => {
  if (typeof value === "string") changePlate(value)
}

const onCarSelected = (carData) => {
  commit_seguro(m("setSearchData"), {
    marca: carData?.marca ?? "",
    ano: carData?.ano ?? "",
    modelo: carData?.modelo ?? "",
  })
}

const onLocalSelected = (alias) => {
  const alias_limpio = (alias ?? "").toString().trim()

  // El select entrega alias (guardado en item.id)
  const local_obj = locales.value.find((l) => String(l.id) === String(alias_limpio))

  const local_id = local_obj?.local_id ?? null
  const id_tabla = local_obj?.id_tabla ?? null

  // Validación por id (solo warning)
  if (id_tabla && local_id && Number(id_tabla) !== Number(local_id)) {
    console.warn(`${TAG} mismatch id_tabla vs local_id`, { alias: alias_limpio, id_tabla, local_id })
  }

  // 1) SearchData (alias + local_id)
  commit_seguro(m("setSearchData"), {
    local: alias_limpio,
    local_id: (local_id === null || local_id === undefined || local_id === "") ? null : Number(local_id),
  })

  // 2) ✅ Detalle Agendamiento: Dirección, Comuna, Región (NUNCA opcion_select)
  const local_direccion = local_obj
    ? (local_obj.local_direccion_formateada || formatear_local_direccion(local_obj))
    : ""

  commit_detalle_seguro({
    local_direccion: local_direccion || "",
  })

  // Debug recomendado (1 vez para confirmar)
  console.log(`${TAG} local seleccionado`, {
    alias: alias_limpio,
    local_id,
    direccion_guardada: local_direccion
  })
}

const selectedOption = (value) => {
  const modo = value === "por_patente" ? "por_patente" : "por_auto"

  // ✅ si alguien intenta seleccionar un modo oculto, no hacemos nada
  if (!modos_disponibles.value.includes(modo)) return

  commit_seguro(m("resetSearchData"))
  commit_seguro(m("resetDetalle"))

  commit_seguro(m("setSearchData"), { modo_busqueda: modo })
}

const isSearching = ref(false)
const locales = ref([])
const loadingLocales = ref(false)

const loadLocales = async () => {
  try {
    loadingLocales.value = true
    const response = await $fetch("/api/locales", { query: { action: "getLocalesLeonSelector" } })

    if (response?.status === "success" && response?.data) {
      console.log("[loadLocales]: ",response);
      console.log("[loadLocales]: ",response.data);
      locales.value = response.data.map((local) => {
        const id_tabla = limpiar_campo_tabla(local?.id)

        // (si tu API trae `local_id`, úsalo; si no, cae a `id`)
        const local_id = limpiar_campo_tabla(local?.local_id) || id_tabla || null

        const direccion = obtener_direccion(local)
        const comuna    = obtener_comuna(local)
        const region    = obtener_region(local)

        return {
          id: local.alias,             // value del Select (alias)
          nombre: local.opcion_select, // label visible

          local_id: local_id ? Number(local_id) : null,
          id_tabla: id_tabla ? Number(id_tabla) : null,

          // ✅ campos “reales”
          direccion,
          comuna,
          region,

          // ✅ texto final requerido
          local_direccion_formateada: [direccion, comuna, region].filter(Boolean).join(", "),
        }
      })

    } else {
      console.error("Error en respuesta de locales:", response)
      locales.value = []
    }
  } catch (error) {
    console.error("Error cargando locales:", error)
    locales.value = []
  } finally {
    loadingLocales.value = false
  }
}

const handleSearch = async () => {
  try {
    isSearching.value = true
    const targetRoute = "/calendario"

    // rescata el local_id que ya guardaste al seleccionar el local
    const local_id = (searchData.value?.local_id ?? null)
    const tipo_busqueda = modo_busqueda_efectivo.value

    if (tipo_busqueda === "por_patente") {
      const patenteData = {
        patente: patenteActual.value,
        local: selectedLocal.value,
        local_id,
      }

      if (!validarDatosPatente(patenteData)) throw new Error("Datos de patente incompletos")

      const ok = commit_seguro(m("setPatenteSearch"), patenteData)
      if (!ok) throw new Error("Mutation setPatenteSearch no existe en el módulo")
    } else {
      const vehiculoData = {
        marca: searchData.value.marca,
        ano: searchData.value.ano,
        modelo: searchData.value.modelo,
        local: selectedLocal.value,
        local_id,
      }

      if (!validarDatosVehiculo(vehiculoData)) throw new Error("Datos de vehículo incompletos")

      const ok = commit_seguro(m("setAutoSearch"), vehiculoData)
      if (!ok) throw new Error("Mutation setAutoSearch no existe en el módulo")
    }

    const modo = (modo_sistema_efectivo.value || "").trim()
    const path = modo ? `/${modo}${targetRoute}` : targetRoute
    await router.push(path)
  } catch (error) {
    console.error("Error en búsqueda:", error)
    alert("Error al procesar la búsqueda. Intenta nuevamente.")
  } finally {
    isSearching.value = false
  }
  console.log(`${TAG} handleSearch fin:`, { searchData: searchData.value })
}

onMounted(() => {
  loadLocales()
  commit_seguro(m("loadFromStorage"))

  // ✅ Corrige store si venía con modo no permitido (ej: por_auto desde storage, pero auto está oculto)
  const modo_actual = limpiar(searchData.value?.modo_busqueda) || ""
  const modo_permitido = modo_busqueda_efectivo.value

  if (modo_actual !== modo_permitido) {
    const payload = { modo_busqueda: modo_permitido }

    // opcional: limpieza mínima del modo que quedó oculto
    if (modo_permitido === "por_patente") {
      payload.marca = ""
      payload.modelo = ""
      payload.ano = ""
    } else {
      payload.patente = ""
    }

    commit_seguro(m("setSearchData"), payload)
  }

  console.log(`${TAG} data:`, {
    ns: ns.value,
    modo_sistema_efectivo: modo_sistema_efectivo.value,
    searchData: searchData.value,
    tipo: selectedSearchType.value,
  })
})
</script>

<style scoped>
/* ===== SelectCustomV2 hardening (pixel-perfect wrapper) ===== */
.leon_select_wrapper :deep(button),
.leon_select_wrapper :deep(.trigger),
.leon_select_wrapper :deep(.select-trigger),
.leon_select_wrapper :deep(.select-button) {
  width: 100%;
  height: 100%;
  border: none !important;
  background: transparent !important;
  padding: 0 !important;
  display: flex;
  align-items: center;
  font-size: 15px;
}

.leon_select--center :deep(button),
.leon_select--center :deep(.trigger),
.leon_select--center :deep(.select-trigger),
.leon_select--center :deep(.select-button) {
  justify-content: center;
  text-align: center;
  color: #bdbdbd;
  font-weight: 500;
}

.leon_select--left :deep(button),
.leon_select--left :deep(.trigger),
.leon_select--left :deep(.select-trigger),
.leon_select--left :deep(.select-button) {
  justify-content: flex-start;
  text-align: left;
  padding: 0 14px !important;
  color: #262626;
  font-weight: 500;
}
</style>
